import {useEffect} from 'react';

import {I18N_REDUCER_STATE_ID} from '../i18n_constants';
import {i18nSlice} from '../i18n_slice';
import {
  ApplicationLocale,
  constants,
  LocaleMessagesType,
  LogUtils,
} from 'src/js/common';
import {useApiQuery} from 'src/js/hooks/useApiQuery';
import {useAppDispatch, useAppSelector} from 'src/js/store_hooks';

const logger = LogUtils.getLogger(
  'useLoadTranslations',
  constants.LIBRARY_NAME
);

export interface UseLoadTranslationsReturnValue {
  isLoading: boolean;
  error: unknown;
}

export function useLoadTranslations(
  apiUrl: string,
  locale: ApplicationLocale,
  id: string
): UseLoadTranslationsReturnValue {
  const isInitialized = useAppSelector(
    (state) => state[I18N_REDUCER_STATE_ID].isDynamicTranslationInitialized[id]
  );

  const {data, isLoading, error} = useApiQuery<LocaleMessagesType>(
    [apiUrl],
    null,
    {
      axiosConfig: {url: apiUrl, params: {language: locale}},
      reactQueryOptions: {
        enabled: !isInitialized,
      },
    },
    false
  );

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (data && !isInitialized) {
      dispatch(
        i18nSlice.actions.addLocaleMessages({
          messages: data,
          locale,
          id,
        })
      );
    }
  }, [id, data, dispatch, locale, isInitialized]);

  useEffect(() => {
    if (error) {
      logger.warn(`Error when loading translations!\n ${error}`);
    }
  }, [error]);

  return {isLoading, error};
}
